// 第三方常量地址

export const ONECLUB_URL = {
  account: `${process.env.ONECLUB_URL}/admin/account`,
  manager: `${process.env.ONECLUB_URL}/admin/manager`,
  // 钱包
  wallet: `${process.env.ONECLUB_URL}/admin/wallet`,
}

export enum ApplyTypeEnum {
  /** 申请服务产品子账号 */
  express_account = 'express_account',
  seller_kyc = 'seller_kyc',
}
